import React, { FC } from 'react';
import { BrowserRouter as Router } from 'react-router-dom';

import ErrorBoundary from 'buyside/components/presentation/ErrorBoundary/errorBoundary';
import JobVaultIndexPage from 'buyside/components/presentation/JobVaultIndexPage/jobVaultIndexPage';

import { jobVaultPostingsUrl } from 'buyside/util/urlHelper';

const JobVaultIndexPageRoot: FC = () => {
  return (
    <ErrorBoundary pageName="the job vault">
      <Router basename={jobVaultPostingsUrl()}>
        <JobVaultIndexPage />
      </Router>
    </ErrorBoundary>
  );
};

export default JobVaultIndexPageRoot;
